import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { useScopedRouteContext } from "../authRouterHelpers";
import { rootRoute } from "./__root";

const LazySignUp = lazyRouteComponent(
  () =>
    import(
      /* webpackChunkName: "OnboardingSignUp" */ "@circle-react/components/OnboardingPage/SignUp"
    ),
  "SignUp",
);

const CommunitySignUpRoute = () => {
  const { hasEmail = false } = useScopedRouteContext({ from: rootRoute.id });

  return <LazySignUp hasEmail={hasEmail} />;
};

export const signUpRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/sign_up",
  component: CommunitySignUpRoute,
});
